<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <PageHeaderModal link-href="/">
      <TextHeading variant="subtitle" color="secondary">Chief Executive Officer</TextHeading>
      <TextHeading variant="lg" block>David Potts</TextHeading>
    </PageHeaderModal>
    <PageGrid modal>
      <PageMain>
        <PageSection>
          <div class="biography">
            <div class="biography__image">
              <figure>
                <img :src="getImage" alt="Alt description for the image">
              </figure>
            </div>
            <div class="biography__info">
              <TextProse>
                <h2>Experience</h2>
                <p>David is a vastly experienced retailer who joined Tesco PLC at the age of 16 and worked there for 39 years. He rose to become CEO of its Ireland business, its UK retail stores business and then CEO of Tesco Asia. David was also on the Tesco PLC Board from 1998 until he left in 2011. Prior to his appointment as CEO of Morrisons, David held several advisory positions with a number of private equity and consultancy firms and developed his own retail concept to sell general merchandise.</p>
                <h2>External Roles</h2>
                <ul>
                  <li>Chief Executive Officer of Greene King PLC</li>
                  <li>Chairman of Purity Soft Drinks Limited</li>
                </ul>
              </TextProse>
            </div>
          </div>
        </PageSection>
      </PageMain>
    </PageGrid>
    <FooterInfo></FooterInfo>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import TheFooter from '../components/TheFooter.vue'
import FooterInfo from '../components/FooterInfo.vue'
import TextProse from '../elements/TextProse.vue'
import PageSection from '../elements/PageSection.vue'
import PageMain from '../elements/PageMain.vue'
import PageGrid from '../elements/PageGrid.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeaderModal from '../components/PageHeaderModal.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'PageBiographies',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeaderModal,
    TextHeading,
    PageGrid,
    PageMain,
    PageSection,
    TextProse,
    FooterInfo,
    TheFooter
  },
  props: {
    image: {
      type: String,
      default: 'david_potts_x2.jpg'
    }
  },
  computed: {
    getImage() {
      return require('@/assets/images/' + this.image)
    }
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>
<style lang="postcss">
.biography {
  @apply flex flex-col;
}
.biography__image {
  @apply flex-1 mb-8;
}
.biography__image figure {
  @apply aspect-ratio-16/9 bg-body-dark relative overflow-hidden;
}
.biography__image img {
  @apply block absolute inset-y-0 inset-x-0 w-full h-full;
  object-fit: contain;
}
.biography__info {
  @apply flex-1;
}
@screen md {
  .biography {
    @apply flex-row justify-center;
  }
  .biography__image figure {
    @apply py-0;
  }
  .biography__image img {
    @apply relative h-auto w-auto;
    object-fit: initial;
  }
  .biography__image {
    @apply mr-4 mb-0;
  }
  .biography__info {
    @apply ml-4;
  }
}
</style>